<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>Also by the same author,</span></p>
<p class="ded2"><span>IMPERIAL HIGHNESS</span></p>
<p class="ded1"><span>CURSE NOT THE KING</span></p>
<p class="ded1"><span>FAR FLY THE EAGLES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?8f4b7dd4